module.exports = __webpack_public_path__ + "img/NFO.e843fd4c.svg";